export default __webpack_public_path__ + "static/media/ecobank.b7004d72.png";